export default "__VITE_ASSET__BQtdtVIO__"